// Single source of truth for image URLs across the site.
// User-uploaded photos + curated stock to avoid duplication.

export const PHOTOS = {
  // User-uploaded photos
  meeting4: "https://customer-assets.emergentagent.com/job_recovery-refined/artifacts/i1dydiu8_pexels-moe-magners-7495163.jpg",
  therapy3: "https://customer-assets.emergentagent.com/job_recovery-refined/artifacts/4tgsk0bw_pexels-shvets-production-7176137.jpg",
  groupTherapy: "https://customer-assets.emergentagent.com/job_recovery-refined/artifacts/e0fm10gl_pexels-shvets-production-7176305.jpg",
  conversation: "https://customer-assets.emergentagent.com/job_recovery-refined/artifacts/djr2ssim_pexels-shkrabaanthony-7579310.jpg",
  // New uploads
  groupCircle: "https://customer-assets.emergentagent.com/job_recovery-refined/artifacts/7mvkhjeq_pexels-tima-miroshnichenko-5711034.jpg",
  tableMeeting: "https://customer-assets.emergentagent.com/job_recovery-refined/artifacts/u9fklfff_pexels-tima-miroshnichenko-5686105.jpg",
  diverseTeam: "https://customer-assets.emergentagent.com/job_recovery-refined/artifacts/5k84oyqa_pexels-diva-plavalaguna-6146816.jpg",
  couchTalk: "https://customer-assets.emergentagent.com/job_recovery-refined/artifacts/z40d3w5p_pexels-shkrabaanthony-5217833.jpg",

  // Curated stock (used sparingly, not duplicated)
  handsTree: "https://images.unsplash.com/photo-1527525443983-6e60c75fff46?auto=format&fit=crop&w=1400&q=80",
  warmConversation: "https://images.unsplash.com/photo-1683208529938-8a7fb89c855f?auto=format&fit=crop&w=1400&q=80",
  handsHeart: "https://images.unsplash.com/photo-1610894065081-fce3e6833dcf?auto=format&fit=crop&w=900&q=80",
  handToSun: "https://images.unsplash.com/photo-1492176273113-2d51f47b23b0?auto=format&fit=crop&w=900&q=80",
  forestPath: "https://images.unsplash.com/photo-1470115636492-6d2b56f9146d?auto=format&fit=crop&w=900&q=80",
};
